import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_COMMS_STACK_SUBJECT_LINE_EXPERIMENTATION_ENABLED = createFcmDetails(
	'comms_stack_subject_line_experimentation_enabled',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		description: 'Global flag to enable Bandit experimentation of subject lines in emails.',
		import: false,
	},
);
